module.exports = __webpack_public_path__ + "img/banner-2.4d4c7484.webp";